var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fam"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('me.fam.title')))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('me.fam.subtitle')))]),_c('div',{staticClass:"slides"},[_c('fam-slides')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }